import React, { useState } from 'react';
import { OverlayTrigger, Popover, Button } from 'react-bootstrap';
import { FaInfoCircle } from 'react-icons/fa';

interface InfoIconProps {
    infoText: string;
}

const InfoIcon: React.FC<InfoIconProps> = ({ infoText }) => {
    const [show, setShow] = useState(false);
    const handleToggle = () => setShow(!show);

    const popover = (
        <Popover id="popover-basic">
            <Popover.Body>
                {infoText}
            </Popover.Body>
        </Popover>
    );

    return (
        <OverlayTrigger
            trigger={['hover', 'click']}
            placement="right"
            overlay={popover}
            show={show}
            onToggle={handleToggle}
        >
            <Button variant="link" style={{ padding: 0, margin: 0 }}>
                <FaInfoCircle size={20} />
            </Button>
        </OverlayTrigger>
    );
};

export default InfoIcon;
